import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface DeleteTestState {
    success:boolean,
    message:string,
}

const deleteTestsSlice = createSlice({
    name: "deleteTests",
    initialState: {
        success:false,
        message:""
    } as DeleteTestState,
    reducers: {
        deleteTest: (state, action:PayloadAction<DeleteTestState>) => {
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
        resetDeleteTest: (state) => {
            state.success = false;
            state.message = "";
        },
    },
});

export const { deleteTest,resetDeleteTest } = deleteTestsSlice.actions;
export const deleteTestsReducer = deleteTestsSlice.reducer;
export const deleteTestAction = deleteTestsSlice.actions.deleteTest;